// extracted by mini-css-extract-plugin
export var otherContent = "video-player-module--other-content--Ypsfj";
export var play = "video-player-module--play--oq8x+";
export var playIcon = "video-player-module--play-icon--PEUoe";
export var player = "video-player-module--player--2tQlo";
export var playerWrapper = "video-player-module--playerWrapper--lpc9y";